import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import Header from '../../components/Header';
import ErrorMessage from '../../components/ErrorMessage';
import Main from '../../components/UI/AuxiliaryHoc/Main';
import Paragraph from '../../components/UI/Paragraph';
import Footer from '../../components/UI/AuxiliaryHoc/Footer';

function mapStateToProps({ auth }) {
  return {
    layoutStaticData: auth.layoutStaticData || {},
  };
}

class Auth extends PureComponent {
  render() {
    const {
      layoutStaticData: { code, logoSrc, expirationPopIn, notFoundPage, copyRights, logoHref },
    } = this.props;
    const shortLogo = code === 404 ? <span className="shortLogo" /> : null;

    return (
      <div className="Auth">
        <div className="Auth__row layout-row">
          <Header logoHref={logoHref} logoSrc={logoSrc} />
          <Main className="Auth__content size-cover">
            {expirationPopIn || notFoundPage ? (
              <ErrorMessage
                data={expirationPopIn || notFoundPage}
                className="page"
                shortLogo={shortLogo}
              />
            ) : null}
          </Main>
        </div>
        <Footer className="Footer__row layout-row">
          <div className="App__container">
            {copyRights ? (
              <Paragraph className="Payment__Pci-Dss-info-container__copyRights">
                {copyRights}
              </Paragraph>
            ) : null}
          </div>
        </Footer>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Auth);
